import Const from 'constants';

let UserPointsType = {
    setUserPointsTypeFromStorage(value) {
        return {
            type: Const.SET_USER_POINTS_TYPE,
            value,
        };
    },

    setUserPointsType(value) {
        return (dispatch) => {
            dispatch({
                type: Const.SET_USER_POINTS_TYPE,
                value,
            });

            dispatch(this.recalculatePlayersScores());

            dispatch(
                this.saveDataToStorage('userPointsType', function (state) {
                    const {userPointsType} = state;
                    return userPointsType.getUserPointsType();
                }),
            );
        };
    },
};

export default UserPointsType;
